import { AppBar } from '@mui/material';
import { Link } from '@vibTheme/components/_base/Link';
import VibxLogoWhite from '@public/assets/vibx-logo-white.svg';

/** O mesmo `lg` do Tailwind, que é quem arma o grid de duas colunas da tela de login. */
const LARGURA_DE_DESKTOP = '1024px';

type Props = {
  /**
   * Esconde a barra no desktop.
   *
   * Por `sx`, e não por `lg:hidden`: o Tailwind e o Emotion geram classes de mesma especificidade e
   * quem decide é a ordem de injeção — o CSS do MUI entra depois, então o `display: flex` do
   * `AppBar` vencia e a barra aparecia no desktop. O `sx` disputa dentro do próprio MUI, onde a
   * ordem está a favor.
   */
  somenteMobile?: boolean;
};

/**
 * A barra da marca, sozinha.
 *
 * Separada do `LayoutAppbarOnly` porque a tela de login precisa dela só abaixo de `lg` — ali o
 * layout de desktop é o painel do logo ocupando a coluna da esquerda, e não uma barra no topo.
 */
export default function Appbar({ somenteMobile = false }: Props) {
  return (
    <AppBar
      className="fixed justify-center h-navbarHeight px-4"
      sx={
        somenteMobile
          ? {
              [`@media (min-width:${LARGURA_DE_DESKTOP})`]: { display: 'none' },
            }
          : undefined
      }
    >
      <Link href="/" className="flex items-center w-fit">
        <VibxLogoWhite alt="Vibx Logo" height="40" />
      </Link>
    </AppBar>
  );
}
